import request from 'local_modules/request'
import { useEffect, useState, useCallback, useRef } from 'react'

import useDeepMemo from './useDeepMemo'


const cacheStorage = {}

const useQuery = (options = {}) => {
  const storedCache = options.cache && cacheStorage[options.url]

  const [ state, setState ] = useState({
    isFetching: !options.skip && !storedCache,
    data: storedCache || null,
    errors: null,
  })

  const _interval = useRef(null)
  const isFetched = useRef(options.skip)
  const dataRef   = useRef(null)

  const updatedOptions = useDeepMemo(() => ({
    ...options,
  }), [ options ])

  const handleFetch = useCallback(() => {
    const { method = 'get', url, mock, clearData, cache, ...requestOptions } = updatedOptions

    const storedCache = cache && cacheStorage[url]

    if (storedCache) {
      dataRef.current = storedCache
      setState({ data: dataRef.current, errors: null, isFetching: false })

      return Promise.resolve(storedCache)
    }

    if (!_interval.current && isFetched.current && !mock) {
      if (clearData !== false) {
        dataRef.current = null
      }

      setState({ data: dataRef.current, errors: null, isFetching: true })
    }

    if (!isFetched.current) {
      isFetched.current = true
    }

    if (mock) {
      const _data = updatedOptions.modifyResult ? updatedOptions.modifyResult(mock) : mock

      console.log('mock', { url, data: _data })

      dataRef.current = _data
      setState({ data: dataRef.current, errors: null, isFetching: false })

      return Promise.resolve()
    }

    return request[method](url, requestOptions)
      .then(
        ({ data }) => {
          const _data = updatedOptions.modifyResult ? updatedOptions.modifyResult(data) : data

          if (cache) {
            cacheStorage[url] = _data
          }

          dataRef.current = _data
          setState({ data: dataRef.current, isFetching: false, errors: null })

          return _data
        },
        ({ data: errors = [] }) => {
          if (clearData !== false) {
            dataRef.current = null
          }

          setState({ data: dataRef.current, errors, isFetching: false })
        },
      )
  }, [ updatedOptions ])

  useEffect(() => {
    if (!updatedOptions.skip) {
      handleFetch()

      if (updatedOptions.interval) {
        _interval.current = setInterval(handleFetch, updatedOptions.interval)

        return () => clearInterval(_interval.current)
      }
    }
  }, [ handleFetch, updatedOptions.skip, updatedOptions.interval ])

  return { ...state, fetch: handleFetch, isFailed: Boolean(state.errors) }
}


export default useQuery
